import { FunctionComponent, PropsWithChildren } from 'react';

type LabelProperties = {
    htmlFor?: string;
};

export const FormLabel: FunctionComponent<PropsWithChildren<LabelProperties>> = ({ children, htmlFor }) => {
    return (
        <label className="text-sm font-medium leading-6 text-gray-900 sm:pt-2" data-testid={'form-label'} htmlFor={htmlFor}>
            {children}
        </label>
    );
};
